import React, { useEffect, useState, useRef } from 'react';
import { Modal, Form, Select, Button, Input, Upload, Checkbox, Tag, Space, notification, Popconfirm } from 'antd';
import { useUpdateSwatchLabel } from '../../hooks/useTasks';

const EditSwatch = ({ selectedSwatch, onUpdateSwatchSuccess }) => {
    const [label, setLabel] = useState('');
    const [api, contextHolder] = notification.useNotification();
    const { mutate: updateSupportingArticle } = useUpdateSwatchLabel(onUpdateSwatchSuccess);
    const handleSubmitEditing = async () => {
        updateSupportingArticle({
            swatchId: selectedSwatch._id,
            labelName: label,
        });
    };

    useEffect(() => {
        selectedSwatch?.labelName && setLabel(selectedSwatch?.labelName);
    }, [selectedSwatch]);
    console.log('label: ', selectedSwatch, label);
    return (
        <>
            <div>
                {contextHolder}
                <h3>Edit Swatch: {selectedSwatch?.name}</h3>

                <Form
                    style={{
                        maxWidth: 800,
                        border: '1px solid grey',
                        padding: '20px',
                        borderRadius: '10px',
                        margin: '10px',
                    }}
                >
                    <Form.Item label="Label*">
                        <Space direction="horizontal" align="start">
                            <Input
                                placeholder="Enter new label here..."
                                allowClear
                                enterButton="Add"
                                size="large"
                                value={label}
                                onChange={e => setLabel(e.target.value)}
                            />
                        </Space>
                    </Form.Item>

                    <Form.Item>
                        <Popconfirm
                            title="Update swatch label"
                            description="Are you sure you want to update the label? Existing label would be overwritten."
                            onConfirm={handleSubmitEditing}
                            onCancel={() => {}}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button disabled={!label.trim()}>Update</Button>
                        </Popconfirm>
                    </Form.Item>
                </Form>
            </div>
        </>
    );
};

export default EditSwatch;
